export default "__VITE_ASSET__2af242fa__"